var SparkDigital = SparkDigital || {};

SparkDigital = (function () {

    /***********************************************************
    // GLOBAL - FOR STORING REUSABLE VARIABLES (EG. DOM)
    ***********************************************************/
    var global = {

            debug_mode: $('body').hasClass('debug-mode'), // Debug on-off state

            site_lang:  $('html').attr('lang'), // get site language

            ajax_endpoints: window["ajax_endpoints"],

            // Define ones that are being called everywhere
            elements: {
                body: $("body"),
                iframes: $("body.single iframe"), // Be specific where the iframes might be added
                inlineSmoothScroll: $("a[smooth-scroll], a[href^='#']"), // Select all inline anchors
                inlinePopUps: $('[inline-modal]'), // For all inline popups
                iframePopUps: $('[inline-youtube], [inline-video], [inline-gmaps]'), // For all iframe popups
                lazyload: $('[data-bg], img[data-src], iframe[data-src], video[data-src], .lazy'), // Lazy load bg images, img/iframe/video HTML elements. 
            },

        },
        /***********************************************************
        // COMPONENTS THAT ARE USED ON MORE THAN ONE PAGE & CALLABLE
        ***********************************************************/
        components = {
            modal: {
                inline: function (elements) {
                    var elements = $(elements).length != 0 ? $(elements) : global.elements.inlinePopUps;
                    
                    // if ($(elements).length > 0) {
                    //     $(elements).magnificPopup({
                    //         type: 'inline',
                    //         closeOnContentClick: true,
                    //         fixedContentPos: true,
                    //         mainClass: 'mfp-fade',
                    //         removalDelay: 160,
                    //     });
                    // }

                },
                iframe: function (elements) {
                    var elements = $(elements).length != 0 ? $(elements) : global.elements.iframePopUps;

                    if ($(elements).length > 0) {
                        // $(elements).magnificPopup({
                        //     //disableOn: 700,
                        //     type: 'iframe',
                        //     mainClass: 'mfp-fade',
                        //     removalDelay: 160,
                        //     preloader: false,
                        //     fixedContentPos: false
                        // });
                    }
                },
                gallery: function (elements) {
                    var elements = $(elements).length != 0 ? $(elements) : global.elements.galleries;
                    //console.log($(elements).length);
                    if ($(elements).length > 0) {

                        $(elements).magnificPopup({
                            type: 'image',
                            callbacks: {
                                open: function () {
                                    $('.headerFix').css('padding-right', 15);
                                }, //Fix for header moving when popup triggered
                                close: function () {
                                    $('.headerFix').css('padding-right', 0);
                                }
                            },
                            image: {
                                verticalFit: true,
                                titleSrc: function (item) {
                                    return item.el.parents('.gallery-item').find('.gallery-caption').text();
                                }

                            },
                            gallery: {
                                enabled: true,
                            },
                            mainClass: 'mfp-fade',
                            removalDelay: 160,
                            fixedContentPos: true,
                        });

                        // Separate remote trigger button to fire the magnificPopup gallery
                        var galleryHeaderImage = $(".postTopImage");
                        if ($(galleryHeaderImage).length > 0) {
                            $(galleryHeaderImage).click(function () {
                                $(elements).eq(0).trigger('click');
                                return false;
                            });
                        }
                    }

                },
            },
            privacy_consent: function(){
                // Generator: https://cookieconsent.insites.com
                // Doc: https://www.osano.com/cookieconsent/documentation/about-cookie-consent/
                $(document).ready(function() {

                    // Ensure CookieConsent JS Plugin exists
                    if (typeof window.cookieconsent !== "undefined") { 
	                
                        // Multisite    
                        switch ( global.site_lang ) {
                            // case "fr-FR": // French
                            //    var privacy_content = {
                            //         "message": "Ce site Internet utilise des cookies pour améliorer et personnaliser votre expérience. Pour plus d’informations sur la collecte et l’utilisation de vos informations, y compris l’utilisation de cookies, merci de consulter notre ",
                            //         "link": "politique de confidentialité",
                            //         "dismiss": "Ok",
                            //         "href": "/fr-fr/politique-de-confidentialite",
                            //         "target": "_blank",
                            //    };
                            // 	break;
                                
                            default: // Defaults to English
                                var privacy_content = {
                                    "message": "This website uses cookies to ensure you get the best experience on our website. Please check out our ",
                                    "link": "privacy policy",
                                    "dismiss": "ACCEPT COOKIES",
                                    "href": "/privacy",
                                    "target": "_blank",
                                };
                        };                
                        
                        window.cookieconsent.initialise({
                            //dismissOnTimeout: 10,
                            position: "bottom-right",
                            palette: {
                                "popup": {
                                    //"text": "#fff",
                                    "background": "rgba(102, 201, 186, 1)"
                                }
                            },
                            elements: {
                            //header: '<span class="cc-header">{{header}}</span>&nbsp;',
                            //"message": "<div id='cookieconsent:desc'><p class='small cc-message' style='color:#fff'>{{message}}.</p></div>",
                            "messagelink": "<div id='cookieconsent:desc'><p class='small cc-message' style='color:#fff'>{{message}} <a aria-label='learn more about cookies' tabindex='0' class='cc-link' href='{{href}}' target='_blank'>{{link}}</a>.</p></div>",
                            "dismiss": "<a aria-label='dismiss cookie message' tabindex='0' class='buttonDefault cc-btn cc-dismiss small'>{{dismiss}}</a>"
                            },
                            content: privacy_content,
                        });

                    }

                });
            },
            smoothScroll: function (elements) {

                var elements = $(elements).length != 0 ? $(elements) : global.elements.inlineSmoothScroll;
                if ($(elements).length > 0) {
                    elements.click(function () {

                        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname && this.hash.slice(1) != "#" && this.hash.slice(1) != "" ) {
                            var target = $(this.hash);                            
                            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                            if (target.length) {

                                // Target y position within the browser (24px is faux offset).
                                var scroll_top = target.offset().top - 24;

                                // Sticky menu
                                scroll_top = scroll_top  -  ( $("header .sticky").length > 0 ? parseInt( $("header .sticky").css("height") ) : 0 );

                                // Wordpress Adminbar (Only on desktop, ignored on mobile)
                                if($("#wpadminbar").length > 0 ){
                                    scroll_top = scroll_top -  ( $("#wpadminbar").css("postiion") == "fixed" ? parseInt( $("#wpadminbar").css("height") ) : 0 );
                                }

                                $('html, body').animate({
                                    scrollTop: scroll_top
                                }, 1500);
                                return false;
                            }
                        }

                    });
                }
            },
            stickyHeader: function(){
                // Uses Polyfill for browsers that does not support IntersectionObserver API
                
                //  Navigation target
                var sticky_nav = document.querySelector(".main-header");

                // Sticky Target
                var sticky_target = document.querySelector("#sticky-header-target");
                
                var observer = new IntersectionObserver(function(entries) {
                    // no intersection with screen
                    if(entries[0].intersectionRatio === 0) {
                        $(sticky_nav).addClass('sticky');
                        if (global.debug_mode) {
                            console.log("Sticky Target: Outside");
                        }
                    }
                    // fully intersects with screen
                    else if(entries[0].intersectionRatio === 1){
                        $(sticky_nav).removeClass('sticky');
                        if (global.debug_mode) {
                            console.log("Sticky Target: Inside");
                        }
                    }
                
                }, { threshold: [0,1] });
                
                observer.observe(sticky_target);
            },

            // Compiles HandleBars
            handlebars: {

                // Use for tracking initialisation state
                init: false,

                // Render Template
                render: function( templateElement ){

                    // Initialise helper if haven't 
                    if(this.init === false) this.extend();

                    if(templateElement === "" || templateElement === null ){
                        return false;
                    }
                    
                    //var templateSource = document.getElementById( $(templateElement).attr("ID") ).innerHTML;
                    var templateSource = $(templateElement).html();
                    
                    //console.log( Handlebars.compile(templateSource) );
                    
                    if(templateSource !== "" || templateSource !== null){
                        // Compile handlebars and return
                        return Handlebars.compile(templateSource);
                    }
                    return false;
                },

                // Extend such as additional kelpers
                extend: function(){

                    // debug helper
                    // usage: {{debug}} or {{debug someValue}}
                    // from: @commondream (http://thinkvitamin.com/code/handlebars-js-part-3-tips-and-tricks/)
                    Handlebars.registerHelper("debug", function (optionalValue) {
                        console.log("Current Context");
                        console.log("====================");
                        console.log(this);

                        if (optionalValue) {
                            console.log("Value");
                            console.log("====================");
                            console.log(optionalValue);
                        }
                    });

                    Handlebars.registerHelper('reverse', function (arr) {

                        //console.log(typeof(arr))
                        if (global.polyfill_isArray(arr)) {
                            arr.reverse();
                        } else {
                            arr;
                        }

                    });

                    Handlebars.registerHelper('str_concatnate', function (a, b, opts) {
                        var str_combined = a + '' + b;
                        return new Handlebars.SafeString(str_combined);
                    });

                    Handlebars.registerHelper('str_replace', function (a, b, c, opts) {
                        var str_replaced = a.replace(b, c);
                        return new Handlebars.SafeString(str_replaced);
                    });

                    // Provides conditional string checks
                    Handlebars.registerHelper('if_eq', function (a, b, opts) {
                        if (a === b) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Checks if string contains
                    Handlebars.registerHelper('if_contains', function (a, b, opts) {
                        if (a.indexOf(b) >= 0) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Checks if obj contains
                    Handlebars.registerHelper('if_obj_contains', function (a, b, c, opts) {

                        var obj_founds = global.search_object_by_key(a, b, c);

                        if (obj_founds.length > 0) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Comparsion Check
                    Handlebars.registerHelper('if_compare', function (lvalue, operator, rvalue, opts) {

                        var operators, result;

                        if (arguments.length < 3) {
                            throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
                        }

                        if (opts === undefined) {
                            opts = rvalue;
                            rvalue = operator;
                            operator = "===";
                        }

                        operators = {
                            '==': function (l, r) {
                                return l == r;
                            },
                            '===': function (l, r) {
                                return l === r;
                            },
                            '!=': function (l, r) {
                                return l != r;
                            },
                            '!==': function (l, r) {
                                return l !== r;
                            },
                            '<': function (l, r) {
                                return l < r;
                            },
                            '>': function (l, r) {
                                return l > r;
                            },
                            '<=': function (l, r) {
                                return l <= r;
                            },
                            '>=': function (l, r) {
                                return l >= r;
                            },
                            'typeof': function (l, r) {
                                return typeof l == r;
                            }
                        };

                        if (!operators[operator]) {
                            throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
                        }

                        result = operators[operator](lvalue, rvalue);

                        if (result) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }

                    });

                    //  Format a date
                    //  @link https://github.com/phstc/jquery-dateFormat
                    Handlebars.registerHelper('DateFormat', function (input, dateformat) {

                        // Normalize date to unix time
                        var unixTimestamp = new Date().getTime(input);
                        unixTimestamp = new Date(unixTimestamp).toISOString();

                        dateformat = dateformat == '' ? 'dd/MM/yyyy' : dateformat;

                        if (dateformat == 'pretty') {
                            return new Handlebars.SafeString($.format.prettyDate(new Date(unixTimestamp)));
                        } else {
                            return new Handlebars.SafeString($.format.date(new Date(unixTimestamp), dateformat));
                        }

                    });


                    // Finished initialisation
                    this.init = true;

                }
  
  
            },

            lazyLoad: function(){

                if(typeof(LazyLoad) != 'undefined'){

                    // @link https://github.com/verlok/lazyload
                    // Instantiate LazyLoad and make available for in Global JS scope
                    window.lazyLoadInstance = new LazyLoad({      
                        //use_native: false, // Use browser native implementation if available
                        load_delay: 300, // Set delay loading when there's inline anchor so that it scrolls to the right spot
                    }, global.elements.lazyload );


                    /* 
                    BROWSER'S NATIVE PRINT EVENTS LISTENERS
                    --------------------------------------- 
                    In order to make browsers load all the images before printing
                    even if the user doesn't press the custom print button. 
                    NOTE that this works only partially in some browsers! */
                    var isSafari = /^((?!chrome|android).)*safari/i.test(
                        navigator.userAgent
                    );
                    if (!isSafari) {
                        window.onbeforeprint = function() {
                            window.lazyLoadInstance.loadAll();
                        };
                    } else {
                        // Safari doesn't support the onbeforeprint event
                        var mediaQueryList = window.matchMedia("print");
                        mediaQueryList.addListener(function(mql) {
                            if (mql.matches) {
                                window.lazyLoadInstance.loadAll();
                            }
                        });
                    }

                }

            },


            wow: function() {

                if(typeof(WOW) != 'undefined'){
                    //Wow js
                    wow = new WOW({
                        mobile:true,     
                    })
                    wow.init();
                }

            },

            tabs: function(){

                var tabContainer = $("[tab-container]");

                $("[tab-container]").each(function(){
                    
                    var tabTargets = $(this).find("[tab-targets] li");
                    var tabPanes = $(this).find("[tab-panes] [tab-content]");
                    
                    //console.log("TAB Targets: "+tabTargets.length);
                    //console.log("TAB Panes: "+tabPanes.length);
                    
                    if(tabTargets.length > 0 && tabTargets.length == tabPanes.length){
    
                        $(tabTargets).on("click", function(){
    
                            // Get the array index of this element in relation to array
                            var elIndex = $(tabTargets).index( this );
    
                            $(tabPanes).hide( 0, function(){
                                $( tabPanes[elIndex] ).show();
                            });
    
                            // Remove active state from others
                            $(tabTargets).removeClass("tab-active");
    
                            // Add active state for others
                            $(this).addClass("tab-active");
    
                            // Load AJAX posts on initial click
                            if( $(this).find("a:not([data-type-id=''])") ){
                                components.ajaxPostsInit( $(this), $(tabPanes[elIndex]) );
                            }
    
                        });
    
                        // Pre-selected tab from other pages and load posts                        
                        var hash = window.location.hash;
                        
                        if(hash !== "" && $("a"+hash+"[tab-target]").length > 0){

                            var targetPane = $( $("a"+hash+"[tab-target]").parent() );

                            if( targetPane.length > 0 ){
                                $("a"+hash+"[tab-target]").parent().trigger("click");
                                components.ajaxPostsInit( $("a"+hash+"[tab-target]"), $("#"+targetPane) );
                            }
                        
                        }
                        else{
                            // Default selection of the first tab
                            if( $(tabTargets[0]) != undefined ){
                                $(tabTargets[0]).trigger("click");
                            }

                        }
    
                    }
                    if( tabPanes.length > 0 && $(tabPanes[0]) != undefined ){ // Post Component with single categories (without tabs)
                        $(tabPanes[0]).show();
                    }


                });

            },

            // Use for filter content based on attribute "data-type-id"
            postsFilter: function(){

                $("[filter-container]").each( function(containerIndex) {

                    var filterTarget = $(this).find("[filter-target]");
                    var filterContent = $(this).find("[filter-content]");

                    // Define target id that should show all. Defaults to first one
                    var resetDataID = containerIndex

                    if( $(filterTarget).length != 0 && $(filterContent).length != 0 ){
    
                        $(filterTarget).each( function(index) {
   
                            $(this).on('click', function () {
   
                                // Grab necessary filter types
                                var data_type_id = $(this).data("type-id");
                                var data_type_count = $(this).data("type-count");

                                // Reset element and show reset and show all on click
                                if( $(this)[0].hasAttribute("filter-reset") ) {

                                    // Show all without filtering
                                    $('[data-type-ids]').show();

                                }
                                else{

                                    // DEBUG RELATED
                                    if (global.debug_mode) {
                                        console.log("ID: " + data_type_id + " | Count: " + data_type_count);
                                    }
                                    
                                    if(data_type_id != "" && data_type_count != ""){
    
                                        // Show/Hide all elements
                                        $('[data-type-ids*="' + data_type_id + '"]').show();
                                        //$('[data-type-ids]').not('[data-type-ids*="' + data_type_id + '"]').hide();
                                        $('[data-type-ids]:not([data-type-ids*="' + data_type_id + '"])').hide();
    
                                    }

                                }
                                
                                // Remove for selected/active state for all 
                                $("[filter-active]").removeAttr("filter-active");


                                // Initialise Ajax load button
                                var ajax_load_more_btn = $("[ajax-load-content]");

                                // Set the filter content on Ajax load button
                                if(ajax_load_more_btn.length > 0 ){
                                    $(ajax_load_more_btn).attr("data-type-id-filter", data_type_id );
                                    //$(ajax_load_more_btn).attr("data-type-count",data_type_count );
                                }
                                // Select for the current active filter
                                $(this).parent().attr('filter-active', true);

                                return false;
                            });

                        });

                    }
                    else{
                        // DEBUG RELATED
                        if (global.debug_mode) {
                            console.log("Debug Mode: Tab targets are not the same no. as target content elements");
                        }
                    }
    
                });
    
            },

            // Use for intilising tabs with ajax posts
            ajaxPostsLoad: function(){

                var postsHandleBars =  $("script#template-post-listings");

                var ajaxBtns = $("[tab-content] a[ajax-load-content]");

                if(postsHandleBars.length > 0){

                  
                    // Load Handlebars template
                    var HTMLTemplate = components.handlebars.render( $("script#template-post-listings") );
                
                    if( HTMLTemplate !== false){     

                        // Load More Posts
                        if(ajaxBtns.length > 0){

                            $(ajaxBtns).each( function(index) { 

                                // Define the maximum number of posts per page.
                                // Should ajax results return less than this value, 
                                // max number of posts has been reached, remove button
                                var max_num_of_posts_per_page = $(this).data("type-items-limit");
                                var max_num_of_posts_total = $(this).data("type-count");
    
                                // Container that contains the items
                                var containerEl = $(this).parent().parent();
                                var contentItems = $(containerEl).find("[data-type-ids]");
    
                                //console.log( $(this).closest("featured-three-column-grid") );
    
                                // Completly remove button and when there's nothing more to load
                                if( contentItems.length >= max_num_of_posts_total){
                                    $(this).remove();
                                }
                                else{

                                    // Show button if more posts are available
                                    $(this).toggleClass("hidden");
    
                                    $(this).click( function (event) {
    
                                        // Current ajax button reference for use as reference within Ajax funcitons (Eg. $.when )
                                        var ajaxBtn = $(this);
                                    
                                        if(containerEl.length > 0 && global.ajax_endpoints.get_posts !== undefined && $(ajaxBtn).attr("disabled") != false ){
                                            
                                            // Stop from user from multiple clicks
                                            $(ajaxBtn).attr("disabled", true);
                    
                                            // Get Filter ID
                                            var dataFilterID = $(ajaxBtn).data("type-id-filter");
                                            var dataTagID = $(ajaxBtn).data("type-tag-id");
                                            dataTagID = dataTagID != "" ? dataTagID : "";

                                            
        
                                            // Get last new item timestamp to determine for use as part of the rest api
                                            var lastContentItem = $(containerEl).find(".featured-three-column-single[data-type-ids]:last-of-type");
    
                                            // Get last post date as part of the query or 
                                            var lastContentItemTimestamp = (lastContentItem != undefined && lastContentItem.length > 0 ) ? $(lastContentItem).data("timestamp") : Math.round((new Date()).getTime() / 1000) ;
                                            //console.log($(lastContentItem).text() + ": " + lastContentItemTimestamp);
    
                                            // Construct REST API QUERY parameters
                                            var ajax_params = {
                                                "end_date": lastContentItemTimestamp,
                                                "posts_per_page": max_num_of_posts_per_page,
                                                "cat_id"  : dataFilterID,
                                                "tag_id" : dataTagID
                                            };

                                            
                                            
    
                                            // Inital requests to load category posts into tab
                                            var xhr_category_posts = $.ajax({
                                                url: global.ajax_endpoints.get_posts,
                                                data: ajax_params,
                                                statusCode: {
                                                    404: function() {
                                                        console.log( "Error requesting data" );
                                                    }
                                                }
                                            });
                
                
                                            $.when(xhr_category_posts).done(function(response){
    
                                                if(response != null && response.found_posts > 0 ){
    
                                                    // Ensure that the returing string contains img src
                                                    var posts = response.posts;
                                                
                                                    // Collect output
                                                    var data_output = new Array;
            
                                                    // Compile data into HTML using Handlebars
                                                    var outputHTML = HTMLTemplate( posts );
            
                                                    // Inject HTML
                                                    $(outputHTML).fadeOut();

                                                    if(lastContentItem.length > 0){
                                                        $(outputHTML).insertAfter( lastContentItem );
                                                    }
                                                    else{
                                                        $(outputHTML).prependTo( $(containerEl).find(".featured-three-column-grid") );
                                                    }
                                                    
            
                                                    //$(outputHTML).fadeIn();

                                                    
                                                    if (window.lazyLoadInstance ) {
                                                        window.lazyLoadInstance.update();
                                                    }
            
                                                    // Hide more button if loaded all posts
                                                    if(response.found_posts < max_num_of_posts_per_page){
                                                        $(ajaxBtn).remove();
                                                    }
                                                    else{
                                                        // Stop from user from multiple clicks
                                                        $(ajaxBtn).attr("disabled", false);
                                                    }
            
                                                }
                                                
                                            });
                    
                                        }
                                        
                                        return false;
                                    });


                                }
    
                            } );
                        }

                    }                    
                }

            },

            ajaxPostsInit: function( triggerEl, triggerTarget){

                //Load posts when on first being initialised
                var postsTab = $(triggerEl).find("a:not([data-type-id=''])");
                                            
                if( $(postsTab).length > 0 && parseInt( $(postsTab).data("type-count")) > 0 && $(postsTab).data("posts-initialised") != true ){

                    var thisAjaxBtn = $(triggerTarget).find("a[ajax-load-content]");

                    if($(thisAjaxBtn).length > 0){
                        // Faux click to load post into tab
                        $(thisAjaxBtn).trigger("click");
                        $(postsTab).data("posts-initialised", true);

                    }
                    
                }

            }

        },
        /***********************************************************
        // PAGE SPECIFIC FUNCTIONS
        ***********************************************************/
        pages = function () {
            
            // Specific functions only required Use CSS classname on body tag
            if ($(global.elements.body).hasClass('page-home')) { // Home or Front-Page
                
            }

            if ($(global.elements.body).hasClass('post') ) { // Post or Page

            }

            if ($(global.elements.body).hasClass('search')) { // Search
                // Inline Code here ...
            }

            if ($(global.elements.body).hasClass('archives')) { // Archives, Catgory, Tags, etc.
                // Inline Code here ...
            }

            if ($(global.elements.body).hasClass('category') || $(global.elements.body).hasClass('category-news')) { // Category, Archives, Tags, etc.
                // Inline Code here ...
            }

            if ($(global.elements.body).hasClass('page-template-default')) {
                // Inline Code here ...
            }

            if ($(global.elements.body).hasClass('page')) {
               
                    
            }

            /* Other non-page specific functions for every page */
            /*
            $(global.elements.iframes).each(function (i, iframe) {

                //Exclude Ads from Responsive iframe wrapper
                if ($(iframe).src !== '//tpc.googlesyndication.com/safeframe/') {
                    //$(iframe).wrap("<div class='embed-responsive embed-responsive-16by9'></div>");
                }
            });
            */








        },

        /***********************************************************
        // Other functions as required
        ***********************************************************/
        misc_func = function () {};

        // Initialise JS Class and functions
        return {
            
            init: function () {
                
                // DEBUG RELATED
                if (global.debug_mode) {
                    console.log("Debug Mode: " + global.debug_mode);
                }

                // Page Specific functions
                pages();

                // Components Used throughout the site
                components.stickyHeader();
                components.wow();
                components.lazyLoad();
                components.modal.inline();
                components.modal.iframe();
                components.smoothScroll();
                //components.privacy_consent();
                //components.postsFilter();
                //components.ajaxPostsLoad();
                //components.tabs();

            }
        };

}());






// Document Ready
$(document).ready( function() {

    SparkDigital.init();

    $(".menu > ul > li > a").click(function() {
        if ($(window).width() < 1100) {
          $(".navbar-toggle").click();
        }
    });

    //Testimonial Slider
    var owl = $('.testimonial-slider').owlCarousel({
        loop:true,
        margin:0,
        nav:false,
        navText: ["<div class='prev-slide'></div>","<div class='next-slide'></div>"],
        dots:true,
        lazyLoad: false,
        autoHeight: true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    });


    


      //FAQ Accordian
      $( ".accordian-head" ).click(function() {
       //$('.accordian-content').slideUp("fast");
       //$('.accordian-head').removeClass('accordian-head-active');
       
      if ($(this).next('div').is(':hidden'))
         {  
           $(this).next('div').slideDown("fast");
           $(this).addClass('accordian-head-active');
           }
      else
          {
            $(this).next('div').slideUp("fast");
            $(this).removeClass('accordian-head-active');
           } 
     }); 
     $(".accordian-head").first().click(); 

    
    
});

$(window).on('load', function(){

});

$(window).resize(function() {
    setTimeout(function() {
        
    },120);
});// end window resize function


